import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "value", "isRelative", "hasWeekday", "canHideDay", "size", "mode", "locale", "timezone", "format", "isUnstyled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { prefix } from '../../tools/settings';
import { Styled } from './FormatDateTime.styles';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var FormatDateTime = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      value = _ref.value,
      _ref$isRelative = _ref.isRelative,
      isRelative = _ref$isRelative === void 0 ? false : _ref$isRelative,
      _ref$hasWeekday = _ref.hasWeekday,
      hasWeekday = _ref$hasWeekday === void 0 ? false : _ref$hasWeekday,
      _ref$canHideDay = _ref.canHideDay,
      canHideDay = _ref$canHideDay === void 0 ? false : _ref$canHideDay,
      size = _ref.size,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'local' : _ref$mode,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en-GB' : _ref$locale,
      _ref$timezone = _ref.timezone,
      timezone = _ref$timezone === void 0 ? 'UTC' : _ref$timezone,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'datetime' : _ref$format,
      _ref$isUnstyled = _ref.isUnstyled,
      isUnstyled = _ref$isUnstyled === void 0 ? false : _ref$isUnstyled,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-format-date-time"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var exceptions = ['zh-HANS', 'zh-HANT', 'ja-JP'];
  dayjs.extend(relativeTime);
  var date = typeof value === 'number' ? dayjs.unix(value) : dayjs(value);
  var localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var diffDate1 = dayjs();
  var diffDate2 = date;
  var difference = Math.sign(diffDate1.diff(diffDate2));
  var options = {
    date: _objectSpread(_objectSpread({
      year: 'numeric',
      month: 'short',
      timeZone: mode === 'local' ? localTimezone : timezone
    }, !canHideDay && {
      day: exceptions.includes(locale) ? 'numeric' : '2-digit'
    }), hasWeekday && {
      weekday: 'long'
    }),
    time: _objectSpread({
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h12',
      timeZone: mode === 'local' ? localTimezone : timezone
    }, mode !== 'local' && {
      timeZoneName: 'short'
    })
  };
  var formattedDate = new Intl.DateTimeFormat(locale, options.date).format(date);
  var formattedTime = new Intl.DateTimeFormat(locale, options.time).format(date);
  var rtf = new Intl.RelativeTimeFormat(locale, {
    localeMatcher: 'best fit',
    numeric: 'always',
    style: 'long'
  });
  var calcRelative = date.fromNow(true).replace('a few seconds', "".concat(difference, " second")).replace('a minute', '1 minute').replace('an hour', '1 hour').replace('a day', '1 day').replace('a month', '1 month').replace('a year', '1 year').split(' ');
  return isUnstyled ? isRelative ? rtf.format(difference === 1 ? -Math.abs(calcRelative[0]) : Number(calcRelative[0]), calcRelative[1] === 'second' ? calcRelative[1] : calcRelative[1].replace('s', '')) : _jsxs(_Fragment, {
    children: [(format === 'datetime' || format === 'date') && formattedDate, format === 'datetime' && ' ', (format === 'datetime' || format === 'time') && formattedTime]
  }) : _jsx(ThemeProvider, {
    theme: {
      size: size
    },
    children: isRelative ? _jsx(Styled.Date, {
      title: "".concat(formattedDate, " ").concat(formattedTime),
      className: "date",
      children: rtf.format(difference === 1 ? -Math.abs(calcRelative[0]) : Number(calcRelative[0]), calcRelative[1] === 'second' ? calcRelative[1] : calcRelative[1].replace('s', ''))
    }) : _jsx(Styled.DateTime, _objectSpread(_objectSpread({
      ref: ref,
      className: className
    }, rest), {}, {
      children: _jsxs(_Fragment, {
        children: [(format === 'datetime' || format === 'date') && _jsx(Styled.Date, {
          className: "date",
          title: "".concat(formattedDate),
          children: formattedDate
        }), format === 'datetime' && _jsx(Styled.Spacer, {
          className: "spacer"
        }), (format === 'datetime' || format === 'time') && _jsx(Styled.Time, {
          className: "time",
          title: "".concat(formattedTime),
          children: formattedTime
        })]
      })
    }))
  });
});
FormatDateTime.displayName = 'FormatDateTime';
export default FormatDateTime;